import { combineReducers } from "redux";
import userReducer from "./userReducers";
import giftReducer from "./giftReducers";

 export default combineReducers({
  user: userReducer,
  gift: giftReducer
}); 
